import { UrgencyStateKey } from '../../dto/urgencySummary/UrgencySummaryDTO'

/**
 * Los grupos de estado de una atención: las filas de la tabla «Estado» del resumen y las opciones de la columna «Estado» del
 * detalle. El número es el que el backend filtra (`UrgencySql.STATE_GROUP_*`).
 */
export const URGENCY_STATE_GROUP_ID: Record<UrgencyStateKey, number> = {
  COMPLETED: 1,
  OBSERVATION: 2,
  IN_PROGRESS: 3,
  LEFT: 4,
  DUPLICATE: 5,
}

/** Nombre de cada grupo de estado. El de la base (con errores de tilde) no se muestra. */
export const URGENCY_STATE_MESSAGE_ID: Record<UrgencyStateKey, string> = {
  COMPLETED: 'UrgencySummaryStateCompleted',
  OBSERVATION: 'UrgencySummaryStateObservation',
  IN_PROGRESS: 'UrgencySummaryStateInProgress',
  LEFT: 'UrgencySummaryStateLeft',
  DUPLICATE: 'UrgencySummaryStateDuplicate',
}

/** Los grupos que cuentan como llegadas: todos menos los registros duplicados. */
export const ARRIVAL_STATE_GROUPS: readonly number[] = [
  URGENCY_STATE_GROUP_ID.COMPLETED,
  URGENCY_STATE_GROUP_ID.OBSERVATION,
  URGENCY_STATE_GROUP_ID.IN_PROGRESS,
  URGENCY_STATE_GROUP_ID.LEFT,
]

/** Los grupos que cuentan como atendidos (la tabla por profesional). */
export const ATTENDED_STATE_GROUPS: readonly number[] = [URGENCY_STATE_GROUP_ID.COMPLETED, URGENCY_STATE_GROUP_ID.OBSERVATION]
